import * as Yup from 'yup';

export const validationSchemaFormPhones = Yup.object({
  otp: Yup.string()
    .required('Поле обязательно для заполнения')
    .length(5, 'Невалидный код'),
});
